import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelVariant from './ModelVariantConfiguration';
import { getModelVariantManager, getUserProfileWidget } from '../../selectors/index';
import { describeModelVariantThunk, modelVariantCleanUpThunk,  } from '../../actions/modelVariant';

const mapStateToProps = state => {
  return {
    modelVariantManager: getModelVariantManager(state),
    userProfileWidgets: getUserProfileWidget(state)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariant);
